var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeRoadB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 40 40",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#6D6D6D",
    fillOpacity: 0.7,
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.605 14.59q2.225 0 3.371.654 1.161.654 1.162 2.258 0 1.03-.557 1.718-.54.67-1.554.85v.083q.688.114 1.243.425.573.31.9.884.328.556.328 1.473 0 1.587-1.113 2.47-1.113.868-3.01.868h-4.19V14.589zm.295 4.875q1.374 0 1.881-.441.524-.442.524-1.31 0-.867-.622-1.243-.621-.393-1.98-.393h-1.75v3.387zm-1.948 1.44V24.8h2.144q1.407 0 1.964-.556.572-.556.572-1.473 0-.834-.589-1.342-.573-.524-2.062-.524z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M23.096 32.38a9.4 9.4 0 0 1-1.47.267 14 14 0 0 1-1.47.08q-2.513 0-4.745-.894a13.1 13.1 0 0 1-3.969-2.47A12.9 12.9 0 0 1 8.61 25.65a12.7 12.7 0 0 1-1.336-4.619h1.63A9.8 9.8 0 0 0 10 24.849 11.7 11.7 0 0 0 12.392 28c.971.908 3.314 2.203 3.314 2.203l2.266-2.23zM16.905 7.62a9.4 9.4 0 0 1 1.472-.267q.777-.08 1.5-.08 2.49 0 4.738.894 2.25.895 3.976 2.47a13 13 0 0 1 2.825 3.712 12.3 12.3 0 0 1 1.311 4.619h-1.606a9.8 9.8 0 0 0-1.098-3.818 11.7 11.7 0 0 0-2.396-3.151c-.973-.908-3.32-2.203-3.32-2.203l-2.27 2.23z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeRoadB);
export default __webpack_public_path__ + "static/media/ChangeRoadB.d2f5377443c06ea3d69a91b76259b856.svg";
export { ForwardRef as ReactComponent };